import defaultConfig from './default';

export default {
  default: defaultConfig,
};
